import { z } from 'zod';

export const dashboardSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  collection_id: z.number().nullable(),
});

export type Dashboard = z.infer<typeof dashboardSchema>;
